<template>
    <v-card elevation="0">
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-card-actions class="ma-0 pa-0">
            <merge-history-table></merge-history-table>
        </v-card-actions>
    </v-card>
</template>

<script>
import MergeHistoryTable from "@/modules/mconfigs/views/merge-history/merge-history-table";
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
export default {
    name: "merge-history",
    components: {MergeHistoryTable},
    data: () => ({
        loading: null
    }),
    mounted() {
        this.loading = true
        ConfigStoreUtils.fetchMergeHistory().then(() => {
            this.loading = false
            this.$notify({title: 'Complete!, load history', text: "", type: "succes"});
        }).catch((error) => {
            this.loading = false
            this.$notify({title: 'Error, load history', text: error, type: "error"});
        })
    },
    methods:{}
}
</script>

<style scoped>

</style>